export default __webpack_public_path__ + "static/media/green.2d21b9e4.svg";